/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Typography, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import BackButton from '../BackButton';
import installation1 from '../../../../../../assets/images/ArticleImages/installation1.jpg';
import installation2 from '../../../../../../assets/images/ArticleImages/installation2.jpg';
import memory from '../../../../../../assets/images/ArticleImages/memory.jpg';
import sim from '../../../../../../assets/images/ArticleImages/sim.jpg';
import installationDiagram from '../../../../../../assets/images/ArticleImages/installationDiagram.jpg';
import LED from '../../../../../../assets/images/ArticleImages/LED.jpg';
import AppSetting1 from '../../../../../../assets/images/ArticleImages/AppSetting1.jpg';
import AppSetting2 from '../../../../../../assets/images/ArticleImages/AppSetting2.jpg';
import AppSetting3 from '../../../../../../assets/images/ArticleImages/AppSetting3.jpg';
import AppSetting4 from '../../../../../../assets/images/ArticleImages/AppSetting4.jpg';
import AppSetting5 from '../../../../../../assets/images/ArticleImages/AppSetting5.jpg';
import AppSetting6 from '../../../../../../assets/images/ArticleImages/AppSetting6.jpg';
import AppSetting7 from '../../../../../../assets/images/ArticleImages/AppSetting7.jpg';
import AISetting1 from '../../../../../../assets/images/ArticleImages/AISetting1.jpg';
import AISetting2 from '../../../../../../assets/images/ArticleImages/AISetting2.jpg';
import AISetting3 from '../../../../../../assets/images/ArticleImages/AISetting3.png';
import AISetting4 from '../../../../../../assets/images/ArticleImages/AISetting4.jpg';
import AISetting5 from '../../../../../../assets/images/ArticleImages/AISetting5.jpg';
import AISetting6 from '../../../../../../assets/images/ArticleImages/AISetting6.jpg';
import vehiclewidth from '../../../../../../assets/images/ArticleImages/vehiclewidth.jpg';
import ROI from '../../../../../../assets/images/ArticleImages/ROI.jpg';
import DownloadIcon from '@mui/icons-material/Download'; // Import the Download icon

// Define a type for the content blocks
type ContentBlock =
    | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
    | { type: 'paragraph'; value: string; style?: React.CSSProperties }
    | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties }
    | { type: 'table'; rows: { category: string; feature: string; description: string }[]; subType?: 'default' | 'led' }
    | { type: 'image-row'; images: Array<{ src: string; alt?: string; style?: React.CSSProperties }> };

const NovusLite: React.FC = () => {
    // Page header information
    const title = "Novus Lite Specifications & Installation Manual";

    // Define the content of your article as a list of blocks.
    const contentBlocks: ContentBlock[] = [
        {
            type: 'heading',
            value: "Product Overview",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "The Novus Safe Lite is a cutting-edge automotive safety device that combines GPS, video surveillance and advanced driver assistance features with ADAS and DMS Algorithms. Designed to enhance fleet management, driving safety, and driver behavior standardization, this product integrates artificial intelligence to improve vehicle, driver and road safety.",
        },
        {
            type: 'heading',
            value: "Capabilities",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• 4G network data transmission and positioning</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Two-way communication </strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Remote real-time positioning and track playback</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Advanced Driver Assistance Systems (ADAS)</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Driver Monitoring Systems (DMS)</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• ADAS/ DMS alarm video upload/ playback</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Live Streaming</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• SD Card Support up to 512 GB</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Continue recording</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• SoS Button</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• In Cabin Audio Alert</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• In Cabin View</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "AI-Powered Safety Features",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    The <strong>Novus Safe Lite</strong> uses machine vision technology to detect road risks and unsafe driving behaviors. When an event is detected, an audible alarm alerts the driver, and the event is pushed to the Cloud server on real time.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>ADAS Functions</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Forward Collision Warning</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Alerts the driver if a collision with the vehicle ahead is likely to happen
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Pedestrian Collision Warning</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Detects pedestrians, bicycles, and motorcycles ahead and alerts the driver if a collision is likely to happen.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Harsh Breaking/ harsh Acceleration</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Sudden acceleration with a speed increase of 15kmph/s and Sudden break with speed decrease of 15kmph/s
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>DMS Functions</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Fatigue Driving Alarm</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Detects driver fatigue (eyes closed) and issues a warning.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Distraction Warning</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Alerts the driver if they are not looking at the road ahead.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Smoking Alarm</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Detects smoking behavior and issues a warning.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Calling Alarm</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Detects mobile phone usage and issues a warning.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Seat Belt Detection</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Function:</strong> Alerts the driver if they are not wearing a seat belt.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Features List",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'table',
            rows: [
                { category: "", feature: "Forward collision warning", description: "Alerts the driver when an impending collision with a vehicle ahead is detected based on the vehicle’s speed and the distance to the object." },
                { category: "", feature: "Pedestrian collision warning", description: "Warns the driver if a pedestrian is detected in the path of the vehicle, to prevent a collision." },
                { category: "", feature: "Drowsiness warning", description: "Alerts the driver if signs of fatigue or drowsiness are detected." },
                { category: "", feature: "Distraction warning", description: "Issued when the driver is not looking at the road for an extended period." },
                { category: "", feature: "Phone use warning", description: "Activated when the driver is using a mobile phone while the vehicle is in motion." },
                { category: "", feature: "Smoking warning", description: "Alerts if the driver is detected smoking in the vehicle." },
                { category: "", feature: "Seatbelt warning", description: "Notifies when the driver or passengers are detected not wearing seat belts while the vehicle is moving." },
                { category: "", feature: "Over speeding alert", description: "Alerts the driver when the vehicle exceeds the set speed limit." },
                { category: "", feature: "Night driving alert", description: "Vehicle speed greater than 7kmph for more than 15 minutes between 11 pm and 6 am." },
                { category: "", feature: "Harsh acceleration alert", description: "Sudden acceleration with a speed increase of 15kmph/s" },
                { category: "", feature: "Harsh braking alert", description: "Sudden break with speed decrease of 15kmph/s" },
            ],
        },
        {
            type: 'heading',
            value: "Specifications",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },

        {
            type: 'table',
            rows: [
                { category: "SPECIFICATIONS", feature: "Operating System", description: "Android" },
                { category: "", feature: "CPU", description: "Dual, 1.2GHz" },
                { category: "", feature: "Wi-Fi", description: "Support" },
                { category: "", feature: "4G", description: "Support" },
                { category: "", feature: "GPS", description: "Support" },
                { category: "", feature: "Built-in speakers", description: "Available" },
                { category: "", feature: "Built-in MIC", description: "Available" },
                { category: "Front camera", feature: "Sensor type", description: "2 Megapixel" },
                { category: "", feature: "Resolution", description: "Upto 1080P" },
                { category: "", feature: "Frame rate", description: "1080p@30fps" },
                { category: "Inward-facing camera", feature: "Sensor type", description: "2 Megapixel" },
                { category: "", feature: "Resolution", description: "Upto 1080P" },
                { category: "", feature: "Frame rate", description: "1080p@30fps" },
                { category: "Other", feature: "Power supply", description: "Power supply voltage 12-24V" },
                { category: "", feature: "G-Sensor", description: "Available" },
                { category: "", feature: "Storage", description: "Supports Upto 512 GB" },
                { category: "Operating environment", feature: "Operating temperature", description: "-20℃~+70℃" },
                { category: "", feature: "Storage temperature", description: "-30℃~+80℃" },
                { category: "", feature: "Relative humidity", description: "10% to 90%" },
            ],
        },
        {
            type: 'heading',
            value: "Installation Procedure",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• Selecting a correct mounting location is very important for the device performance. We must mount the Unit on windshield keeping in mind that it should not block the vision of inside camera to driver also it should not block the driver's vision towards road.",
        },
        {
            type: 'paragraph',
            value: "• For PV, Small Cars, Cabs, Etc We should mount the unit on windshield as given below. It should not block the vision of camera as well as the driver. Also, keep in mind that the wipers should not block the vision of outward looking camera.",
        },
        {
            type: 'image',
            src: installation1,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• For CV, Trucks, Buses Etc, The unit should be mount near the driver so that the DMS functions properly. ",
        },
        {
            type: 'image',
            src: installation2,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Keep the unit level and ensure the driver’s face is centered in the inward-facing camera.",
        },
        {
            type: 'paragraph',
            value: "• Keep the device mounted straight and not tilted.",
        },
        {
            type: 'paragraph',
            value: "• The Front facing camera must be clear.",
        },
        {
            type: 'paragraph',
            value: "• Please clean the surface of windshield by alcohol wipe.",
        },
        {
            type: 'paragraph',
            value: "• Make sure the windshield surface is clear and dry before fixing the camera.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Installation Instructions Memory Card Installation</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'image',
            src: memory,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>4G Sim Card Installation</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'image',
            src: sim,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Installation Diagram",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: installationDiagram,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "LED Indicator",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "The following image shows the location of the LED",
        },
        {
            type: 'image',
            src: LED,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "The following table shows the status of the LED:",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'table',
            subType: 'led',
            rows: [
                { category: 'Video recording', feature: 'red/blue', description: 'OFF | Power disconnected' },
                { category: '', feature: 'red/blue', description: 'Solid blue | The system operating but not recording.' },
                { category: '', feature: 'red/blue', description: 'Solid red | Recording video' },
                { category: '4G network', feature: 'yellow', description: 'OFF | No 4G signal' },
                { category: '', feature: 'yellow', description: 'flashing | Get 4G signal, no online platform' },
                { category: '', feature: 'yellow', description: 'Solid yellow | Get 4G signal and online platform' },
                { category: 'GPS', feature: 'green', description: 'OFF | No GPS signal' },
                { category: '', feature: 'green', description: 'flashing | Get GPS signal, not located' },
                { category: '', feature: 'green', description: 'Solid green | GPS signal and successful location' },
            ],
        },
        {
            type: 'heading',
            value: "App Settings:",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• Configuration APP “Novus Lite” installation and preparation",
        },
        {
            type: 'paragraph',
            value: "• Download and install the Novus Lite APP from the mobile app Store or the Appstore for iOS phones.",
        },
        {
            type: 'paragraph',
            value: "• Connect the Device to the App",
        },
        {
            type: 'paragraph',
            value: "• Follow the directions in the APP to connect to your device's WiFi. The first step is to turn on WiFi by pressing the WiFi button on the device. Warning: A device can only be connected to one phone at one time, otherwise errors may occur.",
        },
        {
            type: 'image',
            src: AppSetting1,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Go to your phone wifi settings and try to locate for Novus Safe Lite Wifi network.",
        },
        {
            type: 'image',
            src: AppSetting2,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Select the wifi network and connect by entering the password and switch off the mobile internet.",
        },
        {
            type: 'paragraph',
            value: "• After login to the app, please select the unit and enter to the settings.",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: AppSetting3,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: AppSetting4,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'paragraph',
            value: "• Now by selecting the camera settings, we can configure the Novus Unit and access the parameter settings.",
        },
        {
            type: 'paragraph',
            value: "• Below are the description of available options in the camera settings",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: AppSetting5,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: AppSetting6,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'image',
            src: AppSetting7,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '50%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Speaker Volume – We can control the volume of incabin alerts from this option",
        },
        {
            type: 'paragraph',
            value: "• Loop Recording Duration – The SD card records continue footage for both the cameras in loop. We can control the duration of each recording clip from here. If the SD card is full, it will automatically overwrite the from the first or earliest video on FIFO mode. (First In First Out).",
        },
        {
            type: 'paragraph',
            value: "• AI Settings – We can control or set the ADAS and DMS parameters from this option.",
        },
        {
            type: 'paragraph',
            value: "• Firmware Version – This shows the current Firmware version available in the Novus Unit.",
        },
        {
            type: 'paragraph',
            value: "• Format SD Card – From here, we can format the SD card.",
        },
        {
            type: 'paragraph',
            value: "• Factory Reset – We can rest the Novus unit to default settings.",
        },
        {
            type: 'heading',
            value: "AI Settings (ADAS & DMS)",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image-row',
            images: [
                {
                    src: AISetting1,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: AISetting2,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'image',
            src: AISetting3,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '70%', height: '50%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• From these parameter settings we can control the ADAS/ DMS alerts. We can enable/ disable and select the sensitivity of the desired ADAS/ DMS parameters. With higher sensitivity, detection time will be low",
        },
        {
            type: 'paragraph',
            value: "• With lower sensitivity, detection will be high.",
        },
        {
            type: 'paragraph',
            value: "• From this Steering Wheel Direction, we can select the left side or right-side steering wheel depending upon the geographical location. Like in India it’s right-side steering wheel vehicles available and in US, its left side steering wheel vehicles available",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: AISetting4,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: AISetting5,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'paragraph',
            value: "• From these parameters, we can select the activation speed for the ADAS/ DMS warnings. For Example, If 40KMPH is selected, the particular warning will start getting generated on or above the 40KMPH speed.",
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    NOTE –By default the Pedestrian Collison Warning is activated on or above the speed of 1KMPH
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• From this advance setting option, We can calibrate the front camera (ADAS) by entering the Vehicle type, Unit Height, Unit Distance From the Bumper, Unit Distance From the left wheel and right wheel. ",
        },
        {
            type: 'image',
            src: AISetting6,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '40%', height: '30%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Please use below picture to refer the measurement of above parameters.",
        },
        {
            type: 'image',
            src: vehiclewidth,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• To calibrate the Front camera, Adjust the front camera to see the vanishing point on road and fix the camera",
        },
        {
            type: 'image',
            src: ROI,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Precautions for use",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Warnings:</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Dangerous driving prompts from active safety AI devices cannot replace the driver's driving decisions and operations",
        },
        {
            type: 'paragraph',
            value: "• The dangerous driving prompts issued by active safety artificial intelligence devices are developed based on computer vision and deep learning technology, which cannot guarantee 100% recognition accuracy. For example, under different road conditions and weather conditions, the accuracy rate of algorithm recognition is different.",
        },
        {
            type: 'paragraph',
            value: "• This device is designed to allow the user to increase the awareness of the driving situation when used correctly. If not used properly, the user may be distracted, which can lead to accidents, causing property damage or personal injury. Do not attempt to view the information stored on the device or change the Settings of the device while driving. Only operate the device if your vehicle is stationary and parked in a safe place in compliance with local laws. Always be aware of your surroundings and don't be distracted by the display or phone. Focusing on equipment can lead to dangerous driving. The use of this equipment will be at the user's own risk",
        },
        {
            type: 'paragraph',
            value: "• When installing the device on the vehicle, please do not place the device in a place that prevents the driver from seeing the road or interferes with the operation and control of the vehicle, such as the steering wheel, foot pedals or transmission rods. Do not leave it unfixed on the dashboard of the vehicle. Do not place the device in front of or on top of any airbags.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Maintenance precautions</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Please keep the equipment dry. Do not let the equipment and cables stay in a humid environment, and do not operate the equipment with wet hands, so as to avoid short circuit of the equipment, failure caused by corrosion or electric shock of personnel.",
        },
        {
            type: 'paragraph',
            value: "• Please do not allow the equipment to be subjected to strong impact or vibration, so as not to cause equipment failure.",
        },
        {
            type: 'paragraph',
            value: "• Please do not put the equipment and power supply in too high or too low temperature, otherwise it may lead to equipment failure.",
        },
        {
            type: 'paragraph',
            value: "• Please do not hit, throw, needle the equipment, also avoid dropping or squeezing the equipment.",
        },
        {
            type: 'paragraph',
            value: "• Please do not use power and data cables that are not officially approved or provided.",
        },
        {
            type: 'paragraph',
            value: "• Please do not disassemble the equipment and accessories without authorization, otherwise the equipment and accessories will not be covered by the warranty.",
        },
        {
            type: 'heading',
            value: "Simple troubleshooting",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'table',
            rows: [
                { category: "Problems :", feature: "Answers :", description: "" },
                { category: "Recording invalid", feature: "Please use a FAT32, read/write speed≥C10 class memory card.", description: "" },
                { category: "Loop recording is invalid", feature: "Please check whether the memory card has enough space for recording, if not format the memory card.", description: "" },
                { category: "The video recording is blurry", feature: "Please remove the protective film from the camera lens and clean the lens and windshield.", description: "" },
                { category: "There is no audio on the footage", feature: "Make sure you have audio recording turned ON.", description: "" },
                { category: "The device temperature is too high", feature: "The AI function of the device requires a lot of calculation during operation, so it is normal to cause heat in the body, especially in the area of the heat sink. Please do not touch the heat sink to avoid burning.", description: "" },
                { category: "The file on the memory card cannot be displayed on the computer", feature: "Please change the video player to play. If it still does not work, the memory card may be damaged, please try to format or replace a new memory card.", description: "" },
                { category: "Other", feature: "If the above failure still does not resolve, please restore all settings to factory settings, or contact tech support for more help.", description: "" },
            ],
        },
        {
            type: 'heading',
            value: "Do’s and Don’ts",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'heading',
            value: "Do’s",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Choose a Good Mounting Location</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Mount the device behind the rearview mirror for minimal obstruction.",
        },
        {
            type: 'paragraph',
            value: "• Ensure the device has a clear view of the road ahead/ in-cabin driver view captures essential details without any blind spots.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Install with a Secure Power Connection</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Use a direct power connection to the vehicle’s fuse box or a cigarette lighter adapter to avoid draining the car’s battery when the engine is off.",
        },
        {
            type: 'paragraph',
            value: "• Consider hardwiring the device for a cleaner setup and to prevent cable clutter.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Route Cables Neatly</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Take wires along the edges of the windshield or behind panels to avoid obstruction and keep the interior looking neat.",
        },
        {
            type: 'paragraph',
            value: "• Secure cables with clips or adhesive pads to prevent them from interfering with airbags or other car systems.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Check Legal Requirements</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Be aware of the device laws in your region regarding privacy and the placement of the camera. For example, some areas restrict dashcam installation where it could obstruct your view or where it might be illegal to record audio.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Test Functionality After Installation</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Test the device before driving to ensure it is recording properly and capturing the desired view and generating proper alarms/ events.",
        },
        {
            type: 'paragraph',
            value: "• Check the camera settings and parameters settings before leaving the installation site.",
        },
        {
            type: 'paragraph',
            value: "• Switch the device on TEST MODE to test the device on parking condition.",
        },
        {
            type: 'paragraph',
            value: "• Make sure the TEST MODE is off when you leave the installation site/ vehicle.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Update Firmware Regularly</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Check for software or firmware updates to ensure your device is operating with the latest features and improvements.",
        },
        {
            type: 'heading',
            value: "Don’ts",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Block Your Field of View</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Avoid placing the device in a position that obstructs your vision, such as directly in front of the driver or covering critical parts of the windshield.",
        },
        {
            type: 'paragraph',
            value: "• Never block sensors or cameras used for advanced driver-assistance systems (ADAS)/ Driver Monitoring System (DMS).",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Leave Cables Loose</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Never let cables hang loosely or dangle where they could interfere with the steering wheel or other controls.",
        },
        {
            type: 'paragraph',
            value: "• Avoid running cables across the airbag area, as it could be hazardous in the event of a crash.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Use the Dashcam as a Backup Camera</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• The device is not meant to replace your rearview or backup cameras. Use it to record while driving, but don't rely on it for rearview visibility.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Use Excessive Power</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Avoid using cheap or poorly made power adapters that may not provide consistent voltage, which can lead to malfunction or damage to the device.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Record Audio Without Permission:</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Be aware of local laws regarding audio recording. In some areas, recording conversations (even within your car) can be illegal without consent.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Ignore Regular Maintenance</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Don’t forget to check your device regularly for signs of malfunction or outdated software. You should also ensure the lens is clean and unobstructed.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Overlook Storage</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Use high-quality microSD cards with sufficient capacity and speed to store footage without errors. Avoid using old or cheap memory cards that could cause data corruption or reduced recording performance.",
        },
    ];

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '../../../../../../assets/sampleFile/Novus Lite.pdf'; // Replace with the actual path to your PDF file
        link.download = 'NovusLite_Document.pdf'; // Name of the downloaded file
        link.click();
    };

    // Function to render each content block based on its type.
    const renderContentBlock = (block: ContentBlock, index: number) => {
        switch (block.type) {
            case 'heading':
                return (
                    <Typography
                        key={index}
                        variant={block.variant || 'h4'}
                        style={{ fontWeight: 600, ...block.style }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'paragraph':
                return (
                    <Typography
                        key={index}
                        variant="body1"
                        style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            ...block.style,
                        }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'image':
                return (
                    <Card
                        key={index}
                        style={{
                            overflow: 'hidden',
                            borderRadius: 12,
                            ...block.style,
                        }}
                    >
                        <img
                            src={block.src}
                            alt={block.alt || 'Article image'}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                );
            case 'image-row':
                return (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            gap: '15px',
                            width: '100%',
                        }}
                    >
                        {block.images.map((image, imgIndex) => (
                            <Card
                                key={imgIndex}
                                style={{
                                    overflow: 'hidden',
                                    borderRadius: 12,
                                    ...image.style,
                                }}
                            >
                                <img
                                    src={image.src}
                                    alt={image.alt || 'Article image'}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </Card>
                        ))}
                    </div>
                );
            case 'table':
                if (block.subType === 'led') {
                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        {['LED', 'Color', 'State', 'Description'].map(header => (
                                            <TableCell key={header} style={{ fontWeight: 600, border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                                                {header}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => {
                                        const [state, description] = row.description.split(' | ');
                                        return (
                                            <TableRow key={rowIndex}>
                                                <TableCell style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 400, }}>{row.category}</TableCell>
                                                <TableCell style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 400, }}>{row.feature}</TableCell>
                                                <TableCell style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 400, }}>{state}</TableCell>
                                                <TableCell style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 400, }}>{description}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                }
                // Check if the table is for Features List
                if (block.rows[0]?.feature && !block.rows[0]?.category) {
                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Feature
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Description
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.description}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                }
                // Check if the table is for Specifications or Troubleshooting
                else if (block.rows[0]?.category) {
                    const isTroubleshooting = block.rows.every(row => row.description === "");

                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                {!isTroubleshooting && (
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Category
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Feature
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Description
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                )}
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.category}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            {/* Only show description column if not troubleshooting */}
                                            {!isTroubleshooting && (
                                                <TableCell
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        textAlign: 'left',
                                                        padding: '8px',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {row.description}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                } else {
                    // Render Troubleshooting table
                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Problems
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Answers
                                        </TableCell>
                                        {/* Render the Description header only if at least one row has a non-empty description */}
                                        {block.rows.some(row => row.description.trim() !== "") && (
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Description
                                            </TableCell>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.category}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            {/* Render the Description column only if it is not empty */}
                                            {row.description.trim() !== "" && (
                                                <TableCell
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        textAlign: 'left',
                                                        padding: '8px',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {row.description}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                }
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col w-full">
            <BackButton />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                {/* Header Section */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '766px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {/* Title & Tag Section */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '8px',
                            }}
                        >
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '766px',
                        padding: '16px 0',
                    }}
                >
                    {contentBlocks.map((block, index) => renderContentBlock(block, index))}
                </div>

                {/* Download Button */}
                {/* <div style={{ textAlign: 'center', marginTop: '24px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownload}
                        style={{ padding: '10px 20px', fontSize: '16px' }}
                        startIcon={<DownloadIcon />} // Add the download icon here
                    >
                        Download Document
                    </Button>
                </div> */}

            </div>
        </div>
    );
};

export default NovusLite;